import { styled } from "@mui/material/styles";

export const OrderTabRightComponentContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
}));

export const OrderTabRightComponentDocumentContainer = styled("div")(() => ({
  position: "absolute",
  left: "50%",
  top: "8%",

  width: "calc(50vw - 160px)",
  "@media screen and (max-width: 959px)": {
    display: "none",
  },
}));
